
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

const contactTypes = ['Facebook', 'WhatsApp', 'Telegram'] as const
type ContactType = typeof contactTypes[number]

@Component
export default class ContactWay extends Vue {
  // Facebook 二维码
  imgSrc = 'https://spics.wantu.cn/45521a946b10e647fcfbb750984e7f48.png'

  @Prop({
    type: String,
    default: '',
    // validator: val => ['Facebook', 'WhatsApp', 'Telegram'].indexOf(val) > -1,
    required: true,
    validator: (val: unknown): val is ContactType => {
      return contactTypes.includes(val as ContactType)
    },
  })
  readonly type!: string

  @Prop({
    type: String,
    // validator: val => ['left', 'center', 'right'].indexOf(val) > -1,
    default: 'left',
    validator: (val: unknown): val is string => {
      return ['left', 'center', 'right'].includes(val as string)
    }
  })
  readonly dir!: string

  get isH5() {
    return AppModule.isH5
  }

  clickHandle() {
    if (this.type === 'Facebook') {
      window.open('https://www.facebook.com/PIN2EAT/')
    }
  }
}
